import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { noop } from 'lodash';
import { Menu, Tooltip } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import useRejectDelegationAction from 'components/tables/data/revision/actions/hooks/use-reject-delegation-action';
import { useConfirm } from 'components/modals/message/MessageProvider';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by a delegated user to reject the delegation.
 */
export default function RejectDelegationAction({
  revision,
  onNoLongerAccessible = noop,
  kind,
}: RevisionSingleActionProps) {
  const { rejectDelegation } = useRejectDelegationAction();
  const { confirm } = useConfirm();

  /**
   * Confirms the rejection of the delegation
   */
  const confirmRejectDelegation = () =>
    confirm({
      title: 'Zamietnuť delegovanie',
      content:
        revision.kind === 'revision'
          ? 'Naozaj si prajete zamietnuť delegovanie tejto revíznej správy?'
          : 'Naozaj si prajete zamietnuť delegovanie tohto formulára?',
      onConfirm: () => rejectDelegation({ revision, onNoLongerAccessible }),
    });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Zamietnuť delegovanie" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="subtle-gray" size="md" onClick={confirmRejectDelegation}>
          <IconX />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button variant="subtle-gray" size="md" onClick={confirmRejectDelegation} leftIcon={<IconX />} w={188}>
        Zamietnuť delegovanie
      </Button>
    );
  }

  return (
    <Menu.Item color="gray.8" onClick={confirmRejectDelegation} icon={<IconX stroke={1.5} size={20} />}>
      Zamietnuť delegovanie
    </Menu.Item>
  );
}
